import {Duration, LocalDateTime, LocalTime} from "js-joda";

export function initialiseNightlyUpdate() {
    const timeToReload = LocalDateTime.now().plusDays(1).with(LocalTime.MIDNIGHT);
    const intervalToCheckForReload = Duration.ofMinutes(10).toMillis();

    window.setInterval(function() {
        const now = LocalDateTime.now();

        if (now.isAfter(timeToReload)) {
            window.location.reload();
        }
    }, intervalToCheckForReload);
}
